// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"074fdf738f982ffc","741":"e9fb4cb0531917b2"}[chunkId] + ".js";
};